<template>
  <div class="recovery-form">
    <p class="recovery-form__title">
      Восстановление пароля
    </p>
    <p class="recovery-form__text">
      Email
    </p>
    <pInput
        :value="recoveryFormData.email"
        :placeholder="'Введите вашу почту'"
        @input="setEmail"
    />
    <pButton class="recovery-form__submit" @click="sendRequest">
      Отправить
    </pButton>
    <span class="recovery-form__help">
      У вас нет учетной записи?
      <span
        class="recovery-form__sign"
        @click="authPopupStore.openLoginForm"
      >
        Регистрация
      </span>
    </span>
  </div>
</template>

<script setup lang="ts">
import pInput from '../../common/pInput/pInput.vue'
import pButton from '../../common/pButton/pButton.vue'
import { Ref, ref } from 'vue'
import { useAuthPopup } from './../store/authPopup'
import api from "../api/api";
import { AxiosError } from 'axios';

const authPopupStore = useAuthPopup()
const recoveryFormData: Ref<{email: string}> = ref({
  email: '',
})

function setEmail(event: Event) {
  recoveryFormData.value.email = (event.target as HTMLInputElement).value
}

async function sendRequest() {
  try {
    await api.recoveryPassword({
      email: recoveryFormData.value.email,
    })
    window.showNotification('На вашу почту отправлено сообщение для сброса пароля', 'success')
    authPopupStore.visible = false
  } catch (e: unknown) {
    if (e instanceof AxiosError && e.response?.data?.error) {
      window.showNotification(e.response.data.error, 'warning')
    } else {
      window.showNotification('Произошла ошибка при сбросе пароля', 'error')
    }
  }
}
</script>

<style scoped lang="scss">
$color-yellow: #FFED48;

.recovery-form {
  padding: 23px 16px;
  display: flex;
  flex-direction: column;
  background: #090A0C;
  border-radius: 12px;
  font-family: "Inter", sans-serif;

  &__title {
    text-align: center;
    font-weight: 700;
    font-size: 16px;
    line-height: 18px;
    margin-bottom: 20px;
  }

  &__text {
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    margin: 15px 0 7px;
  }

  &__submit {
    margin: 12px 0;
    font-weight: 600;
  }

  &__help {
    color: #737880;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
  }

  &__sign {
    color: #fff;
    cursor: pointer;

    @media (hover: hover) {
      &:hover {
        transition: color 0.3s;
        color: $color-yellow;
      }
    }
  }
}
</style>